import { useCallback, useMemo, useState } from "react";
import {
  activityMatchesDateRange,
  activityMatchesFilters,
  cycleActivityFilterValue,
  emptyActivityFilters,
} from "../utils/activityFilters";

export const useActivityFiltering = (activity) => {
  const [activityFilters, setActivityFilters] = useState(emptyActivityFilters);
  const [activityDateRange, setActivityDateRange] = useState({
    from: "",
    to: "",
  });

  const activityFiltersForButton = {
    ...activityFilters,
    dateFrom: activityDateRange.from
      ? { [activityDateRange.from]: "include" }
      : {},
    dateTo: activityDateRange.to ? { [activityDateRange.to]: "include" } : {},
  };

  const activityMatchItem = useCallback(
    (entry, f) =>
      activityMatchesFilters(entry, f) &&
      activityMatchesDateRange(entry, activityDateRange),
    [activityDateRange],
  );

  const activityVisibleEntries = useMemo(
    () => activity.filter((e) => activityMatchItem(e, activityFilters)),
    [activity, activityFilters, activityMatchItem],
  );

  const handleToggleActivityFilter = (key, value) =>
    setActivityFilters((prev) => cycleActivityFilterValue(prev, key, value));

  const handleClearActivityFilters = () => {
    setActivityFilters(emptyActivityFilters());
    setActivityDateRange({ from: "", to: "" });
  };

  return {
    activityFilters,
    activityDateRange,
    setActivityDateRange,
    activityFiltersForButton,
    activityMatchItem,
    activityVisibleEntries,
    handleToggleActivityFilter,
    handleClearActivityFilters,
  };
};
